import React from "react";

import wisrLogoImage from "../assets/images/wisr-logo.svg";
import trustPilotStyle from "./trust-pilot-widget.scss";
import { TrustPilotDynamic } from "./dynamic/trust-pilot-dynamic";

export interface TrustPilotProps {
  position?: "center";
  backroundColour?: "pink-100" | "brand-teal-100";
  wisrLogo?: boolean;
}

export const TrustPilotWidget = ({
  position,
  backroundColour = "pink-100",
  wisrLogo = false,
}: TrustPilotProps) => {
  return (
    <div
      className={`trust-pilot ${`background-${backroundColour}`} ${
        position === "center" && "position-center"
      }`}
    >
      <style jsx>{trustPilotStyle}</style>
      <div className={`contents ${position === "center" && "position-center"}`}>
        {wisrLogo && (
          <img className="wisr-logo" src={wisrLogoImage} alt="Wisr logo" />
        )}

        <div className="trustbox-wrapper">
          <TrustPilotDynamic />
        </div>
      </div>
    </div>
  );
};
